import classes from "./errorComponent.module.css";

function ErrorComponent(props) {
  return <p className={classes.errorText}>{props.errorText}</p>;
}
export default ErrorComponent;
